import {h, Fragment, Component} from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import {route} from "preact-router";
import PFeed from "../../../services/prematch-feed";

import * as P from "../mobile-templates/sports.jsx";
import * as T from "../mobile-templates/tournament";
import * as D from "../desktop-templates/prematch-menu.jsx";
import * as I from "../utils/icons.jsx";

import MenuTimeFilter from "../mobile-components/menu-time-filter.jsx"
import SchedulesTimeFilter from "../utils/schedules-time-filter.jsx"
import {CashoutPage as Cashout} from "./cashout";
import User from "../../../services/user";

import {MobileEvent} from "../mobile-pages/prematch-tournament";

import FullSite from "./full-site";

import { 
	PrematchPage as AwrabetPrematchPage,
	Category as AwrabetCategory,
	PrematchPageSports as AwrabetPrematchPageSports,
	CategoriesList as AwrabetCategoriesList,
	SearchComponent as AwrabetSearchComponent,
	PrematchTournamentsList as AwrabetPrematchTournamentsList,
	WrappedPrematchTournamentPage as AwrabetWrappedPrematchTournamentPage,
	TournamentCard as AwrabetTournamentCard
} from "../../awrabet/mobile-pages/prematch.jsx";
import { LiveEventsBadge } from "./home.jsx";

export default function Prematch(props) {
	return <FullSite class="bg-slate-300 text-slate-950 dark:bg-transparent dark:text-inherit"><PrematchPage key={window.location.pathname} {...props} /></FullSite>
}

export class PrematchPage extends AwrabetPrematchPage {
	render({...props}) {
		if (this.state.currentPage == 'selection')
			return <PrematchPageSports key={window.location.pathname} {...this.props} onOpenTournaments={ids => this.openTournaments(ids)} />
		return <PrematchTournamentsList ids={this.state.data} onEmptyTournaments={() => this.openSelection()} />
	}
}

export class Category extends AwrabetCategory {
	render({category, isChecked, toggleCheck}) {
		return <P.CategorySelectionHolder>
			<P.CategorySelectionButtonRow onClick={() => this.setState({open: !this.state.open, wasOpen: true})} >
				<P.CategoryIcon><D.RegionFlag category={category} /></P.CategoryIcon>
				<P.CategoryName>{category.name}</P.CategoryName>
				<P.FlexSeparator />
				{false && <P.CategoryChecbox onChecked={console.log} />}
				<P.CategoryChevron open={this.state.open} />
			</P.CategorySelectionButtonRow>
			{this.state.wasOpen && <P.TournamentSelectionHolder open={this.state.open}>
				{Object.values(category.sub)
					.filter(s => SchedulesTimeFilter.isScheduleAllowed(s))
					.sort((a, b) => a.order - b.order)
					.map(tournament => {
						return <P.TournamentSelectionButtonRow onClick={e => route(this.getTournamentLink(tournament))} >
							<P.CategoryIcon><D.RegionFlag category={category} /></P.CategoryIcon>
							<P.TournamentName>{tournament.name}</P.TournamentName>
							<P.FlexSeparator />
							<P.CategoryChecbox checked={this.props.isChecked(tournament)} onChecked={e => this.props.toggleCheck(tournament)} />
						</P.TournamentSelectionButtonRow>
					})
				}
			</P.TournamentSelectionHolder>}
		</P.CategorySelectionHolder>
	}
}

export class PrematchPageSports extends AwrabetPrematchPageSports {
	render({sportId, onOpenTournaments}) {
		const menu = PFeed.menu;
		return <Fragment>
			<P.HeaderContainer>
				<MenuTimeFilter />
				<SearchComponent />
			</P.HeaderContainer>
			<P.SportsHolder>
				{User.isLogged() && <P.SportLikeButton
					onClick={e => this.setMyBets()}
					active={this.state.showmybets}>
					<P.SportIconBox><I.UserIcon class="h-full text-amber-500" /></P.SportIconBox>
					<P.SportName>My Bets</P.SportName>
				</P.SportLikeButton>}
				<P.SportLikeButton
					onClick={e => this.setFavourites()}
					active={this.FAVOURITES_TAG == this.state.sport}>
					<P.SportIconBox><I.FavouritesIcon class="h-full text-amber-500" /></P.SportIconBox>
					<P.SportName>Favourites</P.SportName>
				</P.SportLikeButton>
				<P.SportLikeButton onClick={e => route('/live')}>
					<P.SportIconBox>
						<I.LiveIcon class="h-full" />
						<LiveEventsBadge />
					</P.SportIconBox>
					<P.SportName>Live</P.SportName>
				</P.SportLikeButton>
				{menu && Object.values(menu)
					.filter(s => SchedulesTimeFilter.isScheduleAllowed(s))
					.sort((a, b) => a.order - b.order)
					.map(sport => {
						return <P.SportButton
								   sport={sport}
								   active={sport.id == this.state.sport}
								   onClick={e => this.setSport(sport)}
								/>
					})
				}
			</P.SportsHolder>
			{!!this.state.showmybets && <Cashout onCloseCallback={() => this.setState({sport: this.state.oldsport, oldsport: null, showmybets: false})} />}
			{this.getCurrentSport() && <CategoriesList 
										   key={this.state.sport} 
										   currentSport={this.getCurrentSport()} 
										   categories={this.getCategories()} 
										   sportId={this.state.sport}
										   onOpenTournaments={onOpenTournaments} />}
		</Fragment>;
	}
}

export class CategoriesList extends AwrabetCategoriesList {
	render({currentSport, categories, sportId, onOpenTournaments}) {
		return <Fragment>
			<P.SportStrip sport={currentSport} />
			<P.PageContainer key={sportId}>
				{categories.map((category, idx) => {
					return <Category category={category} open={idx < 3} isChecked={t => this.state.checked[t.id]} toggleCheck={tournament => this.toggleCheck(tournament)} />
				})}
			</P.PageContainer>
			{this.state.numChecked != 0 && <div class="fixed bottom-10 mx-auto left-1/2">
				<div class="relative -left-1/2">
					<button class="px-3 py-2 rounded bg-slate-700 text-white shadow-lg" onClick={e => onOpenTournaments(this.state.checked)}><Trans>Open selected</Trans></button>
				</div>
			</div>}
		</Fragment>
	}
}

export class SearchComponent extends AwrabetSearchComponent {
	render() {
		return <P.SearchBar
				   onInput={e => this.performEventSearch(e.target.value)}
				   open={!!this.state.content}
				   value={this.state.content}
				   onClick={e => this.setupEvents()}
				   ref={ref => this.rootNode = ref && ref.base}>
			<P.SearchContentWrapper>
				<P.SearchPopupContainer>
					<P.SearchPopupHeader>
						<P.SearchPopupLabel>Search Results ({this.state.results.length})</P.SearchPopupLabel>
						<P.SearchPopupClose onClick={e => this.closePopup()}><I.CloseIconSlim class="h-5" /></P.SearchPopupClose>
					</P.SearchPopupHeader>
					<P.SearchPopupEventsHolder>
						{this.state.results.map(({event, sport, category, tournament}) => (
							<P.SearchEventRow onClick={e => this.openEvent(event)}>
								<P.SearchEventName>{event.home} - {event.away}</P.SearchEventName>
								<P.SearchEventInfoRow>
									<P.SearchEventFlag><D.RegionFlagIcon category={category} /></P.SearchEventFlag>
									<P.SearchEventTournamentName>{sport.name} / {category.name} / {tournament.name}</P.SearchEventTournamentName>
									<P.SearchEventSeparator />
									<P.SearchEventSportFlag>
										<P.SportIconSmall sport={sport} />
									</P.SearchEventSportFlag>
								</P.SearchEventInfoRow>
							</P.SearchEventRow>
						))}
					</P.SearchPopupEventsHolder>
				</P.SearchPopupContainer>
			</P.SearchContentWrapper>
		</P.SearchBar>
	}
}

export class PrematchTournamentsList extends AwrabetPrematchTournamentsList {
	render({onEmptyTournaments}) {
		return <P.PageContainer>
			{[...this.state.ids].map(tId => <WrappedPrematchTournamentPage key={tId} tournamentId={tId}>
				{({tournament}) => <div class="pb-2 bg-slate-900 border-t border-slate-950">
					<TournamentHeader tournamentPath={tId} onClose={e => this.removeTournament(tId)} />
					<TournamentCard tournamentCard={tournament} />
				</div>}
			</WrappedPrematchTournamentPage> )}
		</P.PageContainer>;
	}
}

function TournamentHeader({tournamentPath, onClose}) {
	const [sportId, categoryId, tournamentId] = tournamentPath.split('/').slice(2);
	const sport = PFeed.menu['/sport/'+sportId];
	const category = sport.sub['/category/'+sportId+'/'+categoryId];
	const tournament = category.sub['/tournament/'+sportId+'/'+categoryId+'/'+tournamentId];
	return <div class="fn-tournament-crumb flex h-9 w-full items-center border-b border-b-slate-900 bg-slate-800 text-white">
		<div class="px-4 text-sm">{sport.name}<span class="px-2 text-xs text-slate-500">/</span>{category.name}<span class="px-2 text-xs text-slate-500">/</span>{tournament.name}</div>
		<div class="grow"></div>
		<div class="relative h-full w-9 bg-slate-900 text-white flex items-center justify-center" onClick={onClose}>
			<I.CloseIconSlim class="h-4" />
		</div>
	</div>;
}

export class WrappedPrematchTournamentPage extends AwrabetWrappedPrematchTournamentPage {
	render({tournamentId, children}) {
		if (!this.state.tournamentCard)
			return null;
		
		return children({tournament: this.state.tournamentCard})
	}
}

export class TournamentCard extends AwrabetTournamentCard {
	render({tournamentCard, minEvents = undefined}) {
		const {giornateSorted, displayRuleFiltered} = this.state;

		let uglyMatchlimit = minEvents || Infinity;

		return giornateSorted.filter(s => SchedulesTimeFilter.isEventAllowed(s[0])).map(eventsList => {
			if (uglyMatchlimit <= 0)
				return null;

			const matches = eventsList
				.filter(s => SchedulesTimeFilter.isEventAllowed(s))
				.slice(0, uglyMatchlimit);

			uglyMatchlimit -= matches.length;
			
			return <Fragment>
				<T.TournamentDatesHeader>
					<T.TournamentDate>{this.getLocalEventDate(eventsList[0])}</T.TournamentDate>
					{displayRuleFiltered.map(outcome => <T.OutcomeNameHeader>{outcome.name}</T.OutcomeNameHeader>)}
				</T.TournamentDatesHeader>
				{matches.map(event => {
					const {tournament} = PFeed.getWithParents(event.id);
					return <MobileEvent {...{tournament, event, displayRuleFiltered, tournamentCard}} />
				})}
			</Fragment>;
		})
	}
}
